@if (temporal.active()) {
  <div class="temporal-banner" role="status" [attr.aria-label]="'temporal.banner.ariaLabel' | translate">
    <span class="temporal-banner-text">
      {{ 'temporal.banner.message' | translate: { brand: brandName(), instant: (temporal.asOf() | displayDate:'dateTime') } }}
    </span>
    <!-- temporal.banner.backToday: the en-US LABEL is a DELIBERATE easter egg ("Back to the
         future" — D-18, moved from tooltip to label per Robert's runtime-QA ruling 2026-07-13);
         every other locale keeps its sober "Back to today" translation, and the en tooltip is
         the sober explainer ("Return to today's view"). Not drift — never "fix" the divergence
         (the i18n guard is value-blind; this comment is the guard). -->
    <button type="button" class="temporal-banner-cta" [title]="'temporal.banner.backTooltip' | translate" (click)="exit()">
      {{ 'temporal.banner.backToday' | translate }}
    </button>
  </div>
}
